import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_NAME_VALUE = '';
const DEFAULT_LANGUAGE_VALUE = 'en';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    testName: DEFAULT_NAME_VALUE,
    language: DEFAULT_LANGUAGE_VALUE,
  },
  reducers: {
    setTestName: (state, action) => {
      state.testName = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const { setTestName, setLanguage } = userSlice.actions;

export default userSlice.reducer;
